module.exports = __webpack_public_path__ + "img/05-yi.154d5bdf.png";